import { BrandButtonWhite } from "./form/buttons";
import "./backBtn.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
interface BackButtonProps {
    navigate: any;
    destination: string;
    text?: string;
}

const BackButton = ({navigate, destination, text="Back"}: BackButtonProps) => {
    return (
        <div className="backButton">
            <BrandButtonWhite
                onClick={() => navigate(destination, { replace: true })}
            >
              <FontAwesomeIcon icon={faChevronLeft} /> <span>{text}</span>
            </BrandButtonWhite>
        </div>
    );
}

export default BackButton;